var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewWindowiconGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36797 3.7V9.63333H12.3013V3.7H6.36797ZM6.16797 2.5C5.61568 2.5 5.16797 2.94772 5.16797 3.5V9.83333C5.16797 10.3856 5.61568 10.8333 6.16797 10.8333H12.5013C13.0536 10.8333 13.5013 10.3856 13.5013 9.83333V3.5C13.5013 2.94772 13.0536 2.5 12.5013 2.5H6.16797Z",
    fill: "#33302E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5.23496C3.83137 5.23496 4.1 5.50359 4.1 5.83496V11.5016C4.1 11.7225 4.27909 11.9016 4.5 11.9016H10.1667C10.498 11.9016 10.7667 12.1703 10.7667 12.5016C10.7667 12.833 10.498 13.1016 10.1667 13.1016H4.5C3.61634 13.1016 2.9 12.3853 2.9 11.5016V5.83496C2.9 5.50359 3.16863 5.23496 3.5 5.23496Z",
    fill: "#33302E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWindowiconGray);
export default __webpack_public_path__ + "static/media/NewWindowiconGray.c41408fe5abbfa964e8b349ffbee633a.svg";
export { ForwardRef as ReactComponent };